import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import styles from "../../Calendar.module.css"

const CloseIcon = () => (
  <svg viewBox="0 0 12 12" aria-hidden="true" focusable="false">
    <path d="M3 3l6 6M9 3L3 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)

const FilterChip = ({ label, onRemove }) => (
  <span className={styles.filterChip}>
    <span className={styles.filterChipLabel}>{label}</span>
    <button type="button" className={styles.filterChipRemove} onClick={onRemove} aria-label="Remove">
      <CloseIcon />
    </button>
  </span>
)

FilterChip.propTypes = {
  label: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
}

const FilterChips = ({ chips }) => {
  if (!chips?.length) return null
  return (
    <Flex gap={8} className={styles.selectedFilters} wrap="wrap">
      {chips.map(({ key, label, onRemove }) => (
        <FilterChip key={key} label={label} onRemove={onRemove} />
      ))}
    </Flex>
  )
}

FilterChips.propTypes = {
  chips: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onRemove: PropTypes.func.isRequired,
  })).isRequired,
}

export default FilterChips
